import { useQuery } from '@tanstack/react-query';
import request from '@/services/api';
import { getPresalesList } from '@/lib/adapters/presale';

export const usePresalesList = (params?: {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  courseId?: string;
}) => {
  return useQuery({
    queryKey: ['presales-list', params],
    queryFn: async () => {
      const res = await request.get('/presales', { params });
      const body = res.data?.data ?? res.data;
      const rows = body?.data ?? body;
      return {
        data: getPresalesList(Array.isArray(rows) ? rows : []),
        meta: body?.meta ?? res.data?.meta,
      };
    },
  });
};
